/* The installed wishlist app remains the source of truth for the saved-item badge. */
(() => {
  'use strict';
  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(swat => {
    if (typeof swat.fetch !== 'function') return;
    let refreshTimer, request = 0, count = null;
    const paint = () => {
      if (count === null) return;
      document.querySelectorAll('[data-es-wishlist-count]').forEach(badge => {
        const value = String(count);
        if (badge.textContent !== value) badge.textContent = value;
        const link = badge.closest('[data-es-wishlist-label]');
        if (link) link.setAttribute('aria-label', `${link.dataset.esWishlistLabel}: ${value}`);
      });
    };
    const refresh = () => {
      const current = ++request;
      try {
        swat.fetch(items => {
          if (current !== request || !Array.isArray(items)) return;
          count = items.length;
          paint();
        }, () => {});
      } catch (_) { /* Retain the last known count if the app is temporarily unavailable. */ }
    };
    const schedule = () => { clearTimeout(refreshTimer); refreshTimer = setTimeout(refresh, 100); };
    ['sw:addedtowishlist', 'sw:removedfromwishlist'].forEach(event => swat.evtLayer?.addEventListener(event, schedule));
    window.addEventListener('focus', schedule);
    document.addEventListener('visibilitychange', () => { if (!document.hidden) schedule(); });
    document.addEventListener('shopify:section:load', () => { paint(); schedule(); });
    refresh();
  });
})();
